import { Outlet, useParams } from 'react-router-dom';

import { WizardError } from '../components/WizardError';
import { WizardLoading } from '../components/WizardLoading';
import { useOrganizationsDataQuery } from '../hooks/useOrganizationDataQuery';
import { organizationFormDefaultValues } from '../model/defaultValues';
import { WizardDataProvider } from '../providers/WizardDataProvider';

const RouteDataLayout = () => {
	const { id = '' } = useParams();
	const { isError, isLoading, data } = useOrganizationsDataQuery(
		id,
		organizationFormDefaultValues
	);

	if (isLoading) {
		return <WizardLoading />;
	}

	if (isError) {
		return <WizardError />;
	}

	if (!data) {
		return <WizardError />;
	}

	return (
		<WizardDataProvider mode={!id ? 'create' : 'edit'} defaultValues={data}>
			<Outlet />
		</WizardDataProvider>
	);
};
export default RouteDataLayout;
